import { useEffect, useRef, useState } from "preact/hooks";
import { cars, simTuning, tracks } from "@midnight-pass/content";
import { buildTrack, type CarParams } from "@midnight-pass/sim";
import { Game, type GameStats } from "../game/game";
import { DevOverlay } from "./DevOverlay";
import { Hud } from "./Hud";
import { TuningPanel } from "./TuningPanel";

const CAR_ID = "s13";
const clone = (c: CarParams): CarParams => JSON.parse(JSON.stringify(c)) as CarParams;

/** Phase 1: one car, one track, straight into the driving. Menus arrive in Phase 4. */
export function GameView() {
  const canvasRef = useRef<HTMLCanvasElement>(null);
  const [game, setGame] = useState<Game | null>(null);
  const [stats, setStats] = useState<GameStats | null>(null);
  const [overlay, setOverlay] = useState(false);
  const [tuning, setTuning] = useState(false);
  const [error, setError] = useState("");
  const defaults = useRef(cars.find((c) => c.id === CAR_ID)!.physics);

  useEffect(() => {
    if (!canvasRef.current) return;
    let g: Game;
    try {
      g = new Game(canvasRef.current, buildTrack(tracks[0]!, simTuning), clone(defaults.current));
    } catch (err) {
      console.error(err);
      setError("WebGL is not available in this browser.");
      return;
    }
    g.onStats = setStats;
    g.onToggleOverlay = () => setOverlay((v) => !v);
    if (import.meta.env.DEV) g.onToggleTuning = () => setTuning((v) => !v);
    g.start();
    setGame(g);
    return () => g.dispose();
  }, []);

  return (
    <main class="stage overflow-hidden bg-asphalt-void">
      <canvas ref={canvasRef} class="absolute inset-0 h-full w-full" />
      {error && (
        <p class="absolute inset-0 flex items-center justify-center font-display text-2xl uppercase text-neon-crimson">
          {error}
        </p>
      )}
      {stats && <Hud stats={stats} />}
      {stats && overlay && <DevOverlay stats={stats} />}
      {import.meta.env.DEV && game && tuning && (
        <TuningPanel game={game} defaults={defaults.current} />
      )}
    </main>
  );
}
